import { Injectable } from '@angular/core';
@Injectable()
export class LocationService {
  go(location: string) {
    window.location.href = location;
  }
}
